import { useGlobalState } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { PmtSignUpStep } from '@/modules/pmt/interfaces';
import { gtmClickLoginCta } from '@/utils';
import { useStatsigClient } from '@statsig/react-bindings';
import { useCallback } from 'react';

interface UseEmailSyncPopupReturn {
  openEmailSyncPopup: () => void;
}

export const useEmailSyncPopup = (): UseEmailSyncPopupReturn => {
  const { setIsFromEmailSyncBtn, setCurrentPMTSignUpStep, setShowPMTPopUp } = useGlobalState();
  const { notificationTranslation } = useMyParcelsContext();
  const { identifier } = notificationTranslation;
  const { logEvent } = useStatsigClient();

  const openEmailSyncPopup = useCallback(() => {
    gtmClickLoginCta(identifier);
    logEvent('click_login_cta', undefined, { variant: identifier ?? '' });
    setIsFromEmailSyncBtn(true);
    setCurrentPMTSignUpStep(PmtSignUpStep.SignUp);
    setShowPMTPopUp(true);
  }, [identifier, setIsFromEmailSyncBtn, setCurrentPMTSignUpStep, setShowPMTPopUp]);

  return {
    openEmailSyncPopup,
  };
};
